import { atom } from 'jotai';
import { store } from '@/state/store';

export type PortalFilterState = {
  usersMessagesPerPage: number;
  inboxMessagesPerPage: number;
  outboxMessagesPerPage: number;
  teleIdLogsPerPage: number;
  teleSignLogsPerPage: number;
};

const initialState: PortalFilterState = {
  usersMessagesPerPage: 10,
  inboxMessagesPerPage: 10,
  outboxMessagesPerPage: 10,
  teleIdLogsPerPage: 10,
  teleSignLogsPerPage: 10,
};

export const portalFilterState = atom<PortalFilterState>(initialState);

export const usersPerPage = atom(
  (get) => get(portalFilterState).usersMessagesPerPage,
);

export const inboxMessagesPerPage = atom(
  (get) => get(portalFilterState).inboxMessagesPerPage,
);

export const outboxMessagesPerPage = atom(
  (get) => get(portalFilterState).outboxMessagesPerPage,
);

export const teleIdLogsPerPage = atom(
  (get) => get(portalFilterState).teleIdLogsPerPage,
);

export const teleSignLogsPerPage = atom(
  (get) => get(portalFilterState).teleSignLogsPerPage,
);

export function setPortalFilterState(state: PortalFilterState): void {
  store.set(portalFilterState, state);
}

export function setUsersPerPage(usersMessagesPerPage: number): void {
  setPortalFilterState({
    ...store.get(portalFilterState),
    usersMessagesPerPage,
  });
}

export function setInboxMessagesPerPage(inboxMessagesPerPage: number): void {
  setPortalFilterState({
    ...store.get(portalFilterState),
    inboxMessagesPerPage,
  });
}

export function setOutboxMessagesPerPage(outboxMessagesPerPage: number): void {
  setPortalFilterState({
    ...store.get(portalFilterState),
    outboxMessagesPerPage,
  });
}

export function setTeleIdLogsPerPage(teleIdLogsPerPage: number): void {
  setPortalFilterState({
    ...store.get(portalFilterState),
    teleIdLogsPerPage,
  });
}

export function setTeleSignLogsPerPage(teleSignLogsPerPage: number): void {
  setPortalFilterState({
    ...store.get(portalFilterState),
    teleSignLogsPerPage,
  });
}

export default portalFilterState;
